import { bindingMode, computedFrom, customElement } from 'aurelia-framework';
import { NavModel } from 'aurelia-router';
import { bindable } from 'aurelia-typed-observable-plugin';
import { NavGroupModel, NavItemEventArgs, NavItemModel } from 'model/navigation';

@customElement('application-menu')
export class ApplicationMenuCustomElement {
  @bindable navigation: NavModel[] = [];
  @bindable navGroupModels: NavGroupModel[] = [];
  @bindable clicked = (args: NavItemEventArgs) => true;
  @bindable({ defaultBindingMode: bindingMode.twoWay }) collapsed = false;
  applicationMenu: HTMLDivElement;
  private CLASS_COLLAPSED = "--collapsed";

  attached() {
    this.setCollapsed();
    window.onresize = () => this.setCollapsed();
  }

  @computedFrom('navigation.length')
  get items(): NavItemModel[] {
    const items: NavItemModel[] = [];
    let currentGroup: NavGroupModel = null;
    this.navigation.forEach(nav => {
      if (nav.settings.groupName) {
        if (currentGroup == null || currentGroup.name !== nav.settings.groupName) {
          currentGroup = this.navGroupModels.find(x => x.name === nav.settings.groupName);
          currentGroup.items = [];
          items.push(currentGroup);
        }
        if (nav.isActive)
          currentGroup.isExpanded = true;
        currentGroup.items.push(nav);
      }
      else {
        currentGroup = null;
        items.push(nav);
      }
    })
    return items;
  }

  linkClicked(nav: NavModel, navGroup: NavGroupModel) {
    this.navGroupModels.forEach(x => {
      x.isExpanded = x === navGroup;
    })
    return this.linkClickedInternal(nav);
  }

  groupLinkClicked(navGroup: NavGroupModel) {
    this.navGroupModels.filter(x => x !== navGroup).forEach(x => { x.isExpanded = false; });
    navGroup.isExpanded = !navGroup.isExpanded;
    return false;
  }

  private linkClickedInternal(nav: NavModel) {
    return nav.settings.clicked ? nav.settings.clicked() : this.clicked && this.clicked({ nav: nav });
  }

  collapsClicked() {
    this.applicationMenu.classList.add(this.CLASS_COLLAPSED);
    return false;
  }

  expandClicked() {
    this.applicationMenu.classList.remove(this.CLASS_COLLAPSED);
    return false;
  }

  private setCollapsed() {
    if (window.innerWidth >= 992)
      this.applicationMenu.classList.remove(this.CLASS_COLLAPSED);
    else
      this.applicationMenu.classList.add(this.CLASS_COLLAPSED);
  }
}
